import { useState } from "preact/hooks";
import type { JSX } from "preact";
import { login } from "../actions";
import { authError, signingIn } from "../state";
import { Logo } from "./Logo";

export function Login(): JSX.Element {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");

  const onSubmit = (e: Event): void => {
    e.preventDefault();
    if (!email || !password || signingIn.value) return;
    void login(email.trim(), password);
  };

  return (
    <div class="flex h-full items-center justify-center bg-ink-0 px-4">
      <div class="w-full max-w-sm">
        <div class="mb-8 flex flex-col items-center text-center">
          <Logo size={48} class="mb-4" />
          <h1 class="text-xl font-semibold">MailTrack</h1>
          <p class="mt-1 text-sm text-muted">Sign in with your mail account</p>
        </div>

        <form onSubmit={onSubmit} class="space-y-4 rounded-2xl border border-subtle bg-ink-1 p-6">
          <label class="block">
            <span class="mb-1.5 block text-xs font-medium text-fg-dim">Email</span>
            <input
              class="field"
              type="email"
              autocomplete="username"
              required
              value={email}
              onInput={(e) => setEmail((e.target as HTMLInputElement).value)}
              placeholder="you@example.com"
            />
          </label>
          <label class="block">
            <span class="mb-1.5 block text-xs font-medium text-fg-dim">Password</span>
            <input
              class="field"
              type="password"
              autocomplete="current-password"
              required
              value={password}
              onInput={(e) => setPassword((e.target as HTMLInputElement).value)}
              placeholder="Your password"
            />
          </label>

          {authError.value && (
            <p class="rounded-md bg-danger/10 px-3 py-2 text-sm text-danger">{authError.value}</p>
          )}

          <button type="submit" class="btn-accent w-full" disabled={signingIn.value}>
            {signingIn.value ? "Signing in…" : "Sign in"}
          </button>
        </form>

        <p class="mt-4 text-center text-xs leading-relaxed text-muted">
          Your password is used only to open an IMAP/SMTP session and is never stored.
        </p>
      </div>
    </div>
  );
}
